export const defaultSliderOptions = [
    {
        value: 1,
        label: '1 MILE',
    },
    {
        value: 10,
        label: '10 MILES',
    },
    {
        value: 25,
        label: '25 MILES',
    },
    {
        value: 50,
        label: '50 MILES',
    },
    {
        value: 100,
        label: '100 MILES',
    },
];
